import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonMethodService } from '../../common/commonMethod.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppUtility } from '../../common/apputility';
import { ScrapAgentService } from '../../services/scrap-agent.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-scrap-agent-list',
    templateUrl: './scrapAgentList.component.html',
    // styleUrls: ['./vehicle-list.component.css']
    providers: [CommonMethodService, ScrapAgentService, UserService]
  })

  export class ScrapAgentListComponent implements OnInit, OnDestroy {

    @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('primaryModal1') public primaryModal1: ModalDirective;

    subscribe: Array<Subscription> = [];
    pageable: any;
    loader: boolean = false;

    accountId: number;
    flatId: number;

    //scrap Agent
    scrapAgentList: Array<any> = [];

    scrapAgentName: string;
    scrapAgentId: number;

    constructor(private toaster: ToastrService, private scrapAgentService: ScrapAgentService, private activeRoute: ActivatedRoute,
      private route: Router, private commonMethod: CommonMethodService, private userService: UserService) { }

    ngOnInit() {
      this.accountId = (Number)(sessionStorage.getItem('accountId'));
      this.flatId = (Number)(sessionStorage.getItem('flatId'));
      this.pageable = {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0
      };
      this.activeRoute.queryParams.subscribe(
        params => {
          this.loader = true;
          this.pageable.currentPage = params['page'] ? params['page'] : 1;
          this.subscribe.push(this.scrapAgentService.getScrapAgentList(this.accountId, this.flatId).subscribe(
            data => {
              this.loader = false;
              this.scrapAgentList = JSON.parse(JSON.stringify(data));
            }, error => {
              this.loader = false;
              this.commonMethod.returnErrorMessage(error);
            }));
        }
      );
    }

    registerScrapAgent(): void {

      if (AppUtility.isEmptyString(this.scrapAgentName)) {
        this.toaster.error('Please enter Scrap Agent Name.');
        return;
      }
  
      let details: any = {};
      details.accountId = this.accountId;
      details.scrapAgentName = this.scrapAgentName;
      details.id = this.scrapAgentId;
      details.premiseHierarchyDetailsId = this.flatId;
  
      this.loader = true;
      this.subscribe.push(this.scrapAgentService.registerScrapAgentDetails(details).subscribe(
        data => {
          this.loader = false;
          this.primaryModal.hide();
          this.ngOnInit();
          if (this.scrapAgentId == null) {
            this.toaster.success('Scrap Agent successfully registered.');
          } else {
            this.scrapAgentId = null;
            this.toaster.success('Scrap Agent successfully updated.');
          }
        }, error => {
          this.loader = false;
          this.primaryModal.hide();
          this.commonMethod.returnErrorMessage(error);
        }));
    }
  
    // Edit Scrap Agent
    editScrapAgent(scrap) {
      this.scrapAgentName = scrap.scrapAgentName;
      this.scrapAgentId = scrap.id;
      this.primaryModal.show();
    }
  
    // Modal
  
    clickDeleteModal(scrap) {
      this.scrapAgentId = scrap.id;
      this.scrapAgentName = scrap.scrapAgentName;
      this.primaryModal1.show();
    }
  
    clickOnScrapAgentButton() {
      this.scrapAgentId = null;
      this.scrapAgentName = null;
      this.primaryModal.show();
    }
  
    deleteScrapAgent(): void {
      this.loader = true;
      this.subscribe.push(this.scrapAgentService.deleteScrapAgentDetails(this.scrapAgentId).subscribe(
        data => {
          this.loader = false;
          this.ngOnInit();
          this.primaryModal1.hide();
          this.toaster.success('Scrap Agent details deleted successfully.');
        }, error => {
          this.loader = false;
          this.primaryModal1.hide();
          this.commonMethod.returnErrorMessage(error);
        }));
    }
  
    ngOnDestroy(): void {
        this.subscribe.forEach(destroyExistingValue => {
          destroyExistingValue.unsubscribe();
        });
      }

  }
